import { Injectable } from "@angular/core";
import { IAddEditContract } from "src/app/Models/Interface/Client/Contract/add-edit-contract";
import { DataService } from "../DataService/data.service";
import { Observable } from "rxjs";
import { IBaseData } from "src/app/Models/Interface/Base/base-data";
import { APIName } from "../../Models/APIEndPoints/APIName";
import { IClientContractList } from "src/app/Models/Interface/Client/Contract/client-contract-list";
import { HttpParams } from "@angular/common/http";
import { IEditContract } from "src/app/Models/Interface/Client/Contract/edit-contract";
import { IContractBasicInfo } from "src/app/Models/Interface/Client/Contract/contract-basic-info";

@Injectable({
  providedIn: "root",
})
export class ClientContractService {
  clientContract = {} as IAddEditContract;
  clientEditContract = {} as IEditContract;
  basicInfoData = {} as IContractBasicInfo;

  constructor(private dataService: DataService) {}

  addContract(): Observable<IBaseData<any>> {
    return this.dataService.post(
      APIName.client.contract.addContract,
      this.clientContract
    );
  }

  getContactList(clientId: number): Observable<IClientContractList[]> {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("clientId", clientId);
    return this.dataService.getWithParams(
      APIName.client.contract.getContracts,
      params
    );
  }

  editContract(): Observable<IBaseData<any>> {
    return this.dataService.post(
      APIName.client.contract.editContract,
      this.clientEditContract
    );
  }

  changeStatus(contractId: number): Observable<any> {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("contractId", contractId);
    return this.dataService.getWithParams(
      APIName.client.contract.changeStatus,
      params
    );
  }

  deleteContract(contractId: number): Observable<any> {
    return this.dataService.post(APIName.client.contract.deleteContract, {
      contractId,
    });
  }

  getBasicInfo(clientId: number): Observable<IContractBasicInfo> {
    let params = new HttpParams();
    params = params.append("clientId", clientId);
    return this.dataService.getWithParams(
      APIName.clientContract.basicInfo,
      params
    );
  }

  onReloadBasicInfo(clientId: number): any {
    let params = new HttpParams();
    params = params.append("clientId", clientId);
    this.dataService
      .getWithParams(APIName.clientContract.basicInfo, params)
      .subscribe((res: any) => {
        this.basicInfoData = res;
      });
  }
}
